import styled from "styled-components";
import { useState } from '@wordpress/element';

const Wrapper = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: start;
    gap: 10px;
    margin-top: 10px;
`;

const InputWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
    
    & .label {
        font-size: 13px;
        font-weight: 700;
    }
    & .sub-label {
        font-size: 13px;
        font-weight: 500;
    }
    & input[type=checkbox] {
        position: absolute;
        opacity: 0;
        width: 0;
        height: 0;
    }
    & input[type=checkbox] + .checkbox-label {
      cursor: pointer;
      width: 32px;
      height: 32px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    & input[type=checkbox]:checked + .checkbox-label {
        border: 3px solid #144344;
        color: white;
        background: #144344;
    }
`;

const BorderContainer = styled.div`
    border-radius: 4px;
    border: 1px solid #DBDBDB;
    height: 32px;
    width: 32px;
`;
function CheckBox({label, onChange, checked}) {
    return (
        <InputWrapper>
            <label>
                <input type="checkbox" name="faces" value={label} checked={checked}/>
                <BorderContainer onClick={() => onChange(label, !checked)} className="checkbox-label">
                    <span className="label">{label}</span>
                </BorderContainer>
            </label>
        </InputWrapper>
    )
}
export default function FacesCheckbox({list, handleChange}) {

    const [selected, setSelected] = useState([]);

    const onChange = (label, checked) => {
        let newSelected;
        if (checked) {
            newSelected = [...selected, label];
        } else {
            newSelected = selected.filter(f => f !== label);
        }
        setSelected(newSelected);
        handleChange(newSelected);
    }

    return (
        <Wrapper>
            {list.map(elm => {
                return <CheckBox label={elm} onChange={onChange} checked={selected.indexOf(elm) >= 0} />
            })}
        </Wrapper>
    );
}